import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { GahMatDialogComponent } from '@shared/components/gah-mat-dialog/gah-mat-dialog.component';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

export const CanDeactivateState = {
  defendAgainstBrowserBackButton: false,
};

@Injectable()
export class PendingChangesGuard  {
  constructor(private dialog: MatDialog, private translate: TranslateService) {}
  canDeactivate(component: any): Observable<boolean> | boolean {
    if (component.httpUploaderComponent) {
      if (component.httpUploaderComponent.canDeactivate()) return true;
      const dialogRef = this.triggerPopup();
      return dialogRef.afterClosed().pipe(
        tap((confirmed) => {
          if (!confirmed && CanDeactivateState.defendAgainstBrowserBackButton) {
            history.pushState(null, '', '');
          }
        })
      );
    }
    if (component.asperaUploaderComponent) {
      if (component.asperaUploaderComponent.canDeactivate()) return true;
      const dialogRef = this.triggerPopup();
      return dialogRef.afterClosed().pipe(
        tap((confirmed) => {
          if (!confirmed && CanDeactivateState.defendAgainstBrowserBackButton) {
            history.pushState(null, '', '');
          }
        })
      );
    }
    return true;
  }

  triggerPopup() {
    return this.dialog.open(GahMatDialogComponent, {
      data: {
        title: this.translate.instant('unsaved-changes-warning'),
        message: this.translate.instant('leaving-metadata-form-warning'),
        cancelText: this.translate.instant('stay-on-page-warning'),
        okayText: this.translate.instant('leave-without-saving-warning'),
      },
      disableClose: true,
      panelClass: 'gah-mat-dialog__panel',
      backdropClass: 'gah-mat-dialog__backdrop',
      hasBackdrop: true,
    });
  }
}
